<template>
	<SectionCard title="Nuovi e di ritorno mese per mese" icon="mdi-chart-timeline-variant" subtitle="dalle fotografie dei mesi" no-padding data-tour="timeline">
		<v-simple-table dense>
			<thead>
				<tr>
					<th>Mese</th>
					<th class="text-right">Clienti</th>
					<th style="width: 34%">Nuovi / di ritorno</th>
					<th class="text-right">Nuovi</th>
					<th class="text-right">Di ritorno</th>
					<th class="text-right">Spesa nuovi</th>
					<th class="text-right">Spesa di ritorno</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="m in series" :key="m.month">
					<td class="text-no-wrap">{{ monthLabel(m.month) }}</td>
					<td class="text-right">{{ formatNumber(m.customers) }}</td>
					<td>
						<div class="ct-bar" :title="`${formatNumber(m.newCustomers)} nuovi, ${formatNumber(m.returning)} di ritorno`">
							<div class="ct-new" :style="{ width: `${pct(m.newCustomers)}%` }"></div>
							<div class="ct-ret" :style="{ width: `${pct(m.returning)}%` }"></div>
						</div>
					</td>
					<td class="text-right">{{ formatNumber(m.newCustomers) }}</td>
					<td class="text-right">{{ formatNumber(m.returning) }}</td>
					<td class="text-right">{{ formatEurCents(m.newSpend) }}</td>
					<td class="text-right">{{ formatEurCents(m.returningSpend) }}</td>
				</tr>
			</tbody>
		</v-simple-table>
		<div class="ct-legend pa-3">
			<span><i class="ct-dot ct-new"></i> nuovi</span>
			<span><i class="ct-dot ct-ret"></i> di ritorno</span>
			<span>· la barra è in proporzione al mese con più clienti. Per vedere più mesi scegli Trimestre o Anno.</span>
		</div>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber, monthLabel } from '../format';

export default {
	name: 'CustomersTimeline',
	components: { SectionCard },
	props: {
		series: { type: Array, default: () => [] },
	},
	computed: {
		max() {
			return Math.max(1, ...this.series.map(m => m.customers || 0));
		},
	},
	methods: {
		formatEurCents,
		formatNumber,
		monthLabel,
		pct(v) {
			return Math.round(((v || 0) / this.max) * 1000) / 10;
		},
	},
};
</script>

<style scoped>
.ct-bar {
	display: flex;
	height: 10px;
	border-radius: 5px;
	overflow: hidden;
	background: #eef1f5;
}
.ct-new {
	background: #1976d2;
}
.ct-ret {
	background: #43a047;
}
.ct-legend {
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
	font-size: 12px;
	color: #5f6b7a;
}
.ct-dot {
	display: inline-block;
	width: 10px;
	height: 10px;
	border-radius: 2px;
	vertical-align: middle;
}
</style>
